<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { ClassValue } from "svelte/elements";
	import { ButtonVariant } from "../../../core/schema/ButtonVariant.js";
	import newsPlaceholder from "@core/assets/images/news-placeholder.svg";
	import type { Product } from "@core/schema/Product.js";
	import { getProductsCatalogueDetailPath } from "@core/schema/paths/getProductsCatalogueDetailPath.js";
	import Button from "./common/Button.svelte";
	import Media from "./common/Media.svelte";

	const { product, class: customClass }: { product: Product; class?: ClassValue } = $props();
	const coverPhoto = product.gallery.find((item) => item.photo !== undefined)?.photo;
</script>

<a
	href={getProductsCatalogueDetailPath(product)}
	class={[
		"w-full min-w-0 rounded-xl md:rounded-3xl bg-white/50 backdrop-blur-[8px] overflow-hidden flex flex-col p-2 md:p-4 group/underline",
		"hover:bg-white hover:shadow-[0_0_32px_0_#00AFF040] transition-all",
		customClass,
	]}
>
	<div class="relative">
		<Media
			draggable={false}
			alt={coverPhoto?.title ?? product.name}
			source={coverPhoto ? coverPhoto : { src: newsPlaceholder, type: "image/svg+xml" }}
			class={["w-full aspect-[16/10] rounded-lg", coverPhoto ? "object-cover" : "object-contain bg-cmcbg"]}
			wrapperClass="w-full"
			height={208}
			width={333}
			sourcesets={{
				"<2xl": [210, 0],
				">2xl": [210, 0],
			}}
		/>
	</div>

	<div class="flex flex-col flex-1 h-full">
		<h3 class="text-base md:text-[1.5rem] font-bold text-cmcsecondary mt-3 lg:mt-6">
			<Formatted text={product.name} />
		</h3>

		<p class="text-2xs/[1.6] md:text-xs/[1.6] font-medium line-clamp-4 md:line-clamp-3 my-4 lg:my-6">
			<Formatted text={product.perex} />
		</p>

		<Button type="span" variant={ButtonVariant.Text} icon="arrow" class="mt-auto">
			<Formatted text="hover[[Detail]]" />
		</Button>
	</div>
</a>
